import { Injectable } from "@angular/core";
import { RestService } from "../core/core/rest.service";
import { WorklogRow, Worklog } from "./worklogs.model";
import { UserToSelect } from "../company/users/user-selection.model";
import { ObjectToSelect } from "../core/shared/objectToSelect.model";

@Injectable()
export class WorklogsRest {
    constructor(private http: RestService) {
    }

    public getWorklogs() {
        return this.http.get<WorklogRow[]>('api/worklogs/grid');
    }

    public getUsersRows(customerId: number) {
        return this.http.get<ObjectToSelect[]>(`api/worklogs/users/${customerId}`);
    }

    public getSubordinates(employeeId: number) {
        return this.http.get<ObjectToSelect[]>(`api/worklogs/subordinates`);
    }

    public getCustomerRows() {
        return this.http.get<ObjectToSelect[]>('api/worklogs/customers');
    }

    public deleteWorklog(worklogId: number) {
        return this.http.post('api/worklogs/delete', worklogId);
    }

    public getWorklog(id: number) {
        return this.http.get<Worklog>(`api/worklogs/worklog/${id}`);
    }

    public getEmptyWorklog() {
        return this.http.get<Worklog>(`api/worklogs/worklog/add`);
    }

    public saveWorklog(worklog: Worklog) {
        return this.http.post('api/worklogs/worklog/save', worklog);
    }

    public copyWorklog(worklogId: number) {
        return this.http.post<Worklog>('api/worklogs/copyWorklog', worklogId);
    }
}
